import React, { Component } from 'react'
import './css/footer.css'
import {Button,TextField,CircularProgress,FormControl,InputLabel,OutlinedInput  } from '@material-ui/core'
// import linkedin from '../../assets/image/linkedin.png'
import Fb from '../../assets/image/sosmed/facebook.png'
import Ig from '../../assets/image/sosmed/instagram.png'
import Lnk from '../../assets/image/sosmed/linkedin.png'
import Logo from '../../assets/image/onegml.png'
import Modal from '../../components/modal'
import axios from 'axios'
import {URL,USER,PASS} from '../../service/base_url'
import {get} from 'lodash'
import moment from 'moment'
export default class index extends Component {
    state={
        request_form:false,
        success_form:false,

        name:'',
        phoneNumber:'',
        email:'',
        companyName:'',
        loading:false,
        department:'',
        jobTitle:''
        // jobTitle:''
    }
    onChange=(e)=>{
        e.preventDefault()
        this.setState({[e.target.name]:e.target.value})
    }
    handleDisable=()=>{
        let {name,phoneNumber,email,companyName,department,jobTitle}=this.state
        if(name===''||phoneNumber===''||email===''||companyName===''||department===''||jobTitle===''){
            return true
        }else{
            return false
        }
    }
    submit=(e)=>{
        e.preventDefault()
        this.setState({loading:true})
        let {name,phoneNumber,email,companyName,department,jobTitle}=this.state
        axios.post(`${URL}`,{
            name,phoneNumber,email,companyName,department,jobTitle,action:'subscribe'
        },{
            auth: {
                username: USER,
                password: PASS
              }
        }).then((res)=>{
            if(get(res,'status')==200){
                this.setState({loading:false})

                this.setState({success_form:!this.state.success_form,request_form:!this.state.request_form})
            }else{
                this.setState({loading:false})
                alert('Ops something error')
            }
        })
    }
    toggleRequest=()=>{
        this.setState({request_form:!this.state.request_form})
    }
    toggleSucces=()=>{
        this.setState({success_form:!this.state.success_form})
    }
    sendForm=()=>{
        this.setState({request_form:false,success_form:true})
    }
    children=()=>{
        let {loading}=this.state
        return(
            <div style={{maxHeight:380,overflowY:'scroll',overflowX:'hidden'}}>
                <p>Please fill out the form below for our latest insight and event</p>
                <br/>
                {/* <form onSubmit={this.submit}> */}
                <FormControl variant="outlined" size="small"  className='form-request'>
                    <InputLabel  htmlFor="name">Name<span style={{color:'red'}}>*</span></InputLabel>
                    <OutlinedInput
                        
                        id="name"
                        type='text'
                        name='name'
                        onChange={this.onChange}
                        required
                        labelWidth={60}
                    />
                </FormControl>
                <br/><br/>
                <FormControl variant="outlined" size="small"  className='form-request'>
                    <InputLabel  htmlFor="name">Company Name<span style={{color:'red'}}>*</span></InputLabel>
                    <OutlinedInput
                        
                        id="companyName"
                        type='text'
                        name='companyName'
                        onChange={this.onChange}
                        required
                        labelWidth={140}
                    />
                </FormControl>
                <br/><br/>
                <FormControl variant="outlined" size="small"  className='form-request'>
                    <InputLabel  htmlFor="name">Department<span style={{color:'red'}}>*</span></InputLabel>
                    <OutlinedInput
                        
                        id="department"
                        type='text'
                        name='department'
                        onChange={this.onChange}
                        required
                        labelWidth={90}
                    />
                </FormControl>
                <br/><br/>
                <FormControl variant="outlined" size="small"  className='form-request'>
                    <InputLabel  htmlFor="name">Job Title<span style={{color:'red'}}>*</span></InputLabel>
                    <OutlinedInput
                        
                        id="jobTitle"
                        type='text'
                        name='jobTitle'
                        onChange={this.onChange}
                        required
                        labelWidth={70}
                    />
                </FormControl>
                <br/><br/>
               
                 <FormControl variant="outlined" size="small"  className='form-request'>
                    <InputLabel  htmlFor="email">Email<span style={{color:'red'}}>*</span></InputLabel>
                    <OutlinedInput
                        
                        id="email"
                        type='email'
                        name='email'
                        onChange={this.onChange}
                        required
                        labelWidth={70}
                    />
                </FormControl>
                <br/><br/>
               
                <FormControl variant="outlined" size="small"  className='form-request'>
                    <InputLabel  htmlFor="phoneNumber">Handphone No.<span style={{color:'red'}}>*</span></InputLabel>
                    <OutlinedInput
                        
                        id="phoneNumber"
                        type='number'
                        name='phoneNumber'
                        onChange={this.onChange}
                        required
                        labelWidth={120}
                    />
                </FormControl>
                <br/><br/>
                
                <Button disabled={this.handleDisable()} onClick={this.submit}  style={{textTransform:'none',width:100}} size="small" color="primary" variant="contained">
                    {loading? <CircularProgress size={20} style={{color:'white'}}/>:'Send'}
                </Button>
                {/* </form> */}
            </div>
        )
    }
    children2=()=>{
        return(
            <div>
                <p>We will send our latest insight and event to your email address</p>
                <br/>
                <Button onClick={this.toggleSucces} style={{textTransform:'none',width:100}} size="small" color="primary" variant="contained">Ok</Button>
            </div>
        )
    }
    render() {
        const{ request_form,success_form}=this.state
    // console.log(`this.state`, this.state)

        return (
            <div className='footer-body'>
                 <Modal title="Subscribe our latest insight and event" isOpen={request_form} children={this.children()} modalToggle={this.toggleRequest}/>
                <Modal title="Thanks for your subscribe" isOpen={success_form} children={this.children2()} modalToggle={this.toggleSucces}/>
                {/* <hr style={{width:'93%',margin:'auto'}}/> */}
                <section className='company'>
                    <div style={{width:300}}>
                       <img src={Logo} />
                    </div>
                    <div className='subscribe-footer' >
                        <h3>Subscribe our latest insight and event</h3>&nbsp;&nbsp;
                        <Button onClick={this.toggleRequest} color="primary" size="medium" variant="contained" style={{textTransform:'none',fontWeight:'bold'}}>Subscribe</Button>
                    </div>
                </section>
                <section className='copyright hidden-mobile'>
                    <ul>
                        <li><a href="/">&copy; {moment().year()} ONE GML Consulting</a></li>
                        <li><a href="/careers">Careers</a></li>
                        <li><a href="/about">About Us</a></li>
                        <li><a href="/contact" >Contact Us</a></li>
                        <li><b>Follow US</b></li>
                        <li>
                            <a href="https://www.linkedin.com/in/knowcapeventmanagement/"><img src={Lnk} style={{width:20,verticalAlign:'middle'}}/></a>
                            &nbsp;&nbsp;
                            <a href="https://www.facebook.com/KnowcapEventManagement/"><img src={Fb} style={{width:20,verticalAlign:'middle'}}/></a>
                            &nbsp;&nbsp;
                            <a href="https://www.instagram.com/knowcapeventmanagement/"><img src={Ig} style={{width:20,verticalAlign:'middle'}}/></a>
                        </li>
                    </ul>
                </section>
                <br/><br/>
                <section className='copyright-mobile show-mobile'>
                    <ul className='copyright-mobile-menu'>
                        <li><a href="/careers">Careers</a></li>
                        <li><a href="/about">About Us</a></li>
                        <li><a href="/contact" >Contact Us</a></li>
                        
                    </ul>
                    <br/>
                    <ul className='sosmed'>
                    <li><b>Follow US</b></li>
                        <li>
                            <a href="https://www.linkedin.com/company/pt-gml-performance-consulting/about/"><img src={Lnk} style={{width:20,verticalAlign:'middle'}}/></a>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <a href="https://www.facebook.com/KreasiCiptaAsia"><img src={Fb} style={{width:20,verticalAlign:'middle'}}/></a>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <a href="https://www.instagram.com/knowcapeventorganizer/"><img src={Ig} style={{width:20,verticalAlign:'middle'}}/></a>
                        </li>
                    </ul>
                    <div className='bottom-copyright'>
                        <p>&copy; {moment().year()} ONE GML Consulting</p>
                    </div>
                </section>
            </div>
        )
    }
}
